export default "__VITE_PUBLIC_ASSET__dfd1f693__"